// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"
import { Element } from "react-scroll"

// COMPONENTS IMPORTS //
import SectionWrapper from "./Shared/SectionWrapper/SectionWrapper"
import SideNavigator, {
  AboutNavigationItemType,
} from "./SideNavigator/SideNavigator"

import HeaderInfo from "./Sections/HeaderInfo/HeaderInfo"
import ProfessionalSkills from "./Sections/ProfessionalSkills/ProfessionalSkills"
import WorkExperience from "./Sections/WorkExperience/WorkExperience"
import EducationHistory from "./Sections/EducationHistory/EducationHistory"
import Footer from "Content/Shared/Layout/Footer/Footer"

import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { GlobalStyles, iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

interface PropsType {}

const sections: Array<AboutNavigationItemType> = [
  {
    title: "Professional skills",
    icon: "fas fa-laptop-code",
    children: ProfessionalSkills,
  },
  {
    title: "Work Experience",
    icon: "fas fa-building",
    children: WorkExperience,
  },
  {
    title: "Education History",
    icon: "fas fa-graduation-cap",
    children: EducationHistory,
  },
]

const AboutScreen: React.FC<PropsType> = () => {
  return (
    <>
      <SuperWrapper>
        <SideNavigator
          navigatorItems={[
            { title: "About", icon: "fas fa-user" },
            ...sections,
          ]}
        />
        <Wrapper>
          <Container>
            <Element name={"About"}>
              <HeaderInfo />
            </Element>
            <ContentWrapper>
              {sections.map((item) => (
                <Element name={item.title}>
                  <SectionWrapper title={item.title}>
                    {item.children && <item.children />}
                  </SectionWrapper>
                </Element>
              ))}
            </ContentWrapper>
          </Container>
        </Wrapper>
      </SuperWrapper>
      <Footer />
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

const SuperWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 100;

  margin-top: ${GlobalStyles.insets.pageTop + 20}px;
  @media (max-width: ${iPhoneResolution}px) {
    margin-top: ${GlobalStyles.insets.pageTopMobile + 20}px;
  }
`

const MARGIN_HORIZONTAL = 40
const MOBILE_SUBTR_VALUE = 18
const Container = styled.div`
  margin-right: ${MARGIN_HORIZONTAL}px;
  margin-left: ${MARGIN_HORIZONTAL}px;

  margin-bottom: 80px;
  text-align: left;
  max-width: 1235px;

  @media (max-width: ${iPhoneResolution}px) {
    margin-right: ${MARGIN_HORIZONTAL - MOBILE_SUBTR_VALUE}px;
    margin-left: ${MARGIN_HORIZONTAL - MOBILE_SUBTR_VALUE}px;
  }
`

const CONTENT_MARGIN_HORIZONTAL = "100px"
const ContentWrapper = styled.div`
  @media (min-width: 900px) {
    margin-left: ${CONTENT_MARGIN_HORIZONTAL};
    margin-right: ${CONTENT_MARGIN_HORIZONTAL};
  }

  margin-top: 50px;
`

export default React.memo(AboutScreen, memoComparison)
